import moment from "moment";
import {renderAmount} from "../../../helpers/renderAmount";

// Gemeinsame Formate für Vorschau „Neu“ und ihre Kurzfassung, damit derselbe Betrag überall gleich aussieht.
export const eur = (amount: number) => renderAmount({amount});
export const date = (value: string | Date) => moment(value).format("DD.MM.YYYY");
export const day = (value: string | Date) => moment(value).format("DD.MM.");
export const changed = (a: number, b: number) => Math.abs(a - b) > 0.005;
// Vorzeichen mit Abstand wie beim Gesamtpreis; eine Null (Raten verschieben sich nur) bekommt „±“ statt eines falschen Plus.
export const signed = (amount: number) => (changed(amount, 0) ? `${amount < 0 ? "−" : "+"} ${eur(Math.abs(amount))}` : `± ${eur(0)}`);
